import styled from 'styled-components'
import { Property } from 'csstype'

type FlexProps = {
  flexDirection?: Property.FlexDirection
  justifyContent?: Property.JustifyContent
}

const Flex = styled.div<FlexProps>`
  display: flex;
  flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
  justify-content: ${({ justifyContent = 'row' }) => justifyContent};
`

export default Flex
